export const searchIcon = (
  <svg
    width="0.5in"
    height="0.55714286in"
    viewBox="0 0 35 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6408_167063)">
      <path
        d="M12.8144 6.51812C11.9926 7.67042 11.4058 8.97331 11.0874 10.3524C10.7691 11.7315 10.7256 13.1598 10.9592 14.5557C11.1929 15.9516 11.6992 17.2879 12.4493 18.4881C13.1994 19.6884 14.1785 20.7291 15.3308 21.551C16.4831 22.3728 17.786 22.9597 19.1651 23.278C20.5442 23.5963 21.9725 23.6399 23.3684 23.4062C24.7643 23.1725 26.1006 22.6662 27.3008 21.9161C28.5011 21.1661 29.5418 20.1869 30.3637 19.0346C31.1855 17.8823 31.7723 16.5794 32.0907 15.2003C32.409 13.8212 32.4526 12.393 32.2189 10.997C31.9852 9.6011 31.4789 8.26486 30.7288 7.06461C29.9787 5.86436 28.9996 4.8236 27.8473 4.00175C26.695 3.17991 25.3921 2.59307 24.013 2.27475C22.6339 1.95644 21.2056 1.91287 19.8097 2.14653C18.4138 2.3802 17.0775 2.88653 15.8773 3.6366C14.677 4.38668 13.6363 5.36582 12.8144 6.51812L12.8144 6.51812Z"
        stroke="#017E9D"
        strokeWidth="2.5"
      />
      <circle
        cx="12.0277"
        cy="12.0277"
        r="10.7777"
        transform="matrix(-0.814143 -0.580665 -0.580665 0.814143 38.3654 9.96815)"
        fill="none"
        stroke="#017E9D"
        strokeWidth="2.5"
      />
      <rect
        x="0.291848"
        y="1.74351"
        width="13.152"
        height="3.54331"
        rx="1.77166"
        transform="matrix(-0.580665 0.814143 0.814143 0.580665 9.13041 23.7483)"
        fill="none"
        stroke="#017E9D"
        strokeWidth="2.5"
      />
      <path
        d="M14.4741 21.2106L11.605 25.2333C11.3318 25.6163 11.4209 26.1481 11.8038 26.4213C12.1868 26.6944 12.7187 26.6054 12.9918 26.2224L15.8609 22.1997L14.4741 21.2106Z"
        fill="#017E9D"
      />
      <path
        d="M18.4725 9.47233C18.2984 8.57974 18.6813 6.79457 21.6053 6.79457C24.5293 6.79457 24.7381 8.57974 24.738 9.47233C24.738 10.3649 24.3207 11.049 23.1716 11.7038C21.6052 12.5964 21.0831 13.0427 21.0831 14.3816"
        stroke="#017E9D"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <ellipse
        cx="21.0477"
        cy="17.7288"
        rx="1.30534"
        ry="1.11573"
        fill="#017E9D"
      />
    </g>
    <defs>
      <clipPath id="clip0_6408_167063">
        <rect width="35" height="39" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const barsIcon = (
  <svg
    width="0.41428571in"
    height="0.55714286in"
    viewBox="0 0 29 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="6"
      height="12"
      fill="none"
      stroke="#017E9D"
      strokeWidth="2"
      rx="1"
      x="2"
      y="25"
    ></rect>
    <rect
      width="6"
      height="16"
      fill="none"
      stroke="#017E9D"
      strokeWidth="2"
      rx="1"
      x="11"
      y="21"
    ></rect>
    <rect
      width="6"
      height="23"
      fill="none"
      stroke="#017E9D"
      strokeWidth="2"
      rx="1"
      x="20"
      y="14"
    ></rect>
    <path
      stroke="#017E9D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="M1.38 13.533l5.06-5.06a5.367 5.367 0 017.718.134v0a5.367 5.367 0 007.847 0l3.79-4.061"
    ></path>
    <path
      stroke="#017E9D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="M20.836 4.515l5.167-.727c.662-.094 1.19.695.974 1.458l-1.28 4.538"
    ></path>
  </svg>
);

export const targetIcon = (
  <svg
    width="0.570099668in"
    height="0.55714286in"
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="21.5029"
      cy="21.5029"
      r="17.3242"
      fill="none"
      stroke="#017E9D"
      strokeWidth="2.5"
    />
    <path
      d="M31.3007 20.1228C31.6136 22.3439 31.1625 24.6054 30.0214 26.5365C28.8803 28.4676 27.117 29.9537 25.0205 30.7511C22.924 31.5485 20.6188 31.6099 18.4828 30.9253C16.3468 30.2406 14.5068 28.8505 13.2646 26.983C12.0223 25.1154 11.4514 22.8811 11.6455 20.6465C11.8397 18.4119 12.7873 16.3096 14.3331 14.6842C15.8788 13.0589 17.931 12.0069 20.153 11.7009C22.3751 11.3949 24.6352 11.853 26.5627 13"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M15.9307 19.8392L19.9669 24.4154C20.3498 24.8495 21.0202 24.8688 21.4274 24.4575L30.79 15.002"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M21.5029 35.4336L21.5029 41.0059"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M21.5029 2L21.5029 7.57226"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M36.3623 21.5029H41.9346"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M2 21.5029H7.57226"
      stroke="#017E9D"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const nasalSprayIcon = (
  <svg
    width="0.3in"
    height="0.85714286in"
    viewBox="0 0 21 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="32.25"
      width="18.5"
      height="26.5"
      rx="1.75"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <mask id="path-2-inside-1_6473_196539" fill="white">
      <path d="M4 27C4 26.4477 4.44772 26 5 26H16C16.5523 26 17 26.4477 17 27V31C17 31.5523 16.5523 32 16 32H5C4.44772 32 4 31.5523 4 31V27Z" />
    </mask>
    <path
      d="M4 27C4 26.4477 4.44772 26 5 26H16C16.5523 26 17 26.4477 17 27V31C17 31.5523 16.5523 32 16 32H5C4.44772 32 4 31.5523 4 31V27Z"
      fill="none"
    />
    <path
      d="M1.5 27C1.5 25.067 3.067 23.5 5 23.5H16C17.933 23.5 19.5 25.067 19.5 27L14.5 28.5H6.5L1.5 27ZM17 32H4H17ZM5 32C3.067 32 1.5 30.433 1.5 28.5V27C1.5 25.067 3.067 23.5 5 23.5L6.5 28.5V31C6.5 31.5523 6.5 32 6.5 32H5ZM16 23.5C17.933 23.5 19.5 25.067 19.5 27V28.5C19.5 30.433 17.933 32 16 32H14.5C14.5 32 14.5 31.5523 14.5 31V28.5L16 23.5Z"
      fill="#017E9D"
      mask="url(#path-2-inside-1_6473_196539)"
    />
    <path
      d="M14 27.25L11.4769 15.7158C11.2476 14.6674 9.75244 14.6674 9.5231 15.7158L7 27.25H14Z"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <path
      d="M10.5 11L10.5 2"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M14 11.5L17 4.5"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M4 4.5L7 11.5"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <line
      x1="1"
      y1="38.75"
      x2="20"
      y2="38.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="1"
      y1="51.75"
      x2="20"
      y2="51.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <mask id="path-10-inside-2_6473_196539" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4564 44.8271L11.0058 41L8.55518 44.8271C8.20559 45.3183 8 45.9191 8 46.568C8 48.2281 9.34574 49.5738 11.0058 49.5738C12.6659 49.5738 14.0116 48.2281 14.0116 46.568C14.0116 45.9191 13.806 45.3183 13.4564 44.8271Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4564 44.8271L11.0058 41L8.55518 44.8271C8.20559 45.3183 8 45.9191 8 46.568C8 48.2281 9.34574 49.5738 11.0058 49.5738C12.6659 49.5738 14.0116 48.2281 14.0116 46.568C14.0116 45.9191 13.806 45.3183 13.4564 44.8271Z"
      fill="#017E9D"
    />
    <path
      d="M11.0058 41L13.1112 39.6519L11.0058 36.364L8.90044 39.6519L11.0058 41ZM13.4564 44.8271L11.3511 46.1752L11.3841 46.2268L11.4196 46.2767L13.4564 44.8271ZM8.55518 44.8271L10.592 46.2767L10.6275 46.2268L10.6605 46.1752L8.55518 44.8271ZM8.90044 42.3481L11.3511 46.1752L15.5618 43.479L13.1112 39.6519L8.90044 42.3481ZM10.6605 46.1752L13.1112 42.3481L8.90044 39.6519L6.44983 43.479L10.6605 46.1752ZM10.5 46.568C10.5 46.4556 10.5338 46.3585 10.592 46.2767L6.51834 43.3775C5.87741 44.2781 5.5 45.3827 5.5 46.568H10.5ZM11.0058 47.0738C10.7265 47.0738 10.5 46.8473 10.5 46.568H5.5C5.5 49.6088 7.96503 52.0738 11.0058 52.0738V47.0738ZM11.5116 46.568C11.5116 46.8473 11.2851 47.0738 11.0058 47.0738V52.0738C14.0466 52.0738 16.5116 49.6088 16.5116 46.568H11.5116ZM11.4196 46.2767C11.4778 46.3585 11.5116 46.4556 11.5116 46.568H16.5116C16.5116 45.3827 16.1342 44.2781 15.4933 43.3775L11.4196 46.2767Z"
      fill="#017E9D"
      mask="url(#path-10-inside-2_6473_196539)"
    />
  </svg>
);

export const rxIcon = (
  <svg
    width="0.42857143in"
    height="0.48571429in"
    viewBox="0 0 30 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.95467"
      y="1.35132"
      width="22.7394"
      height="30.6487"
      fill="none"
    />
    <path
      d="M10.8867 14.9788V4.27002H15.1701C16.0476 4.27002 16.7838 4.41294 17.3787 4.69879C17.9773 4.98463 18.4291 5.38552 18.734 5.90143C19.0426 6.41386 19.1969 7.0117 19.1969 7.69494C19.1969 8.38167 19.0408 8.97776 18.7284 9.48322C18.4198 9.98519 17.9643 10.3739 17.362 10.6493C16.7596 10.9212 16.0197 11.0571 15.1422 11.0571H12.0914V9.44662H14.8633C15.3764 9.44662 15.7966 9.38039 16.1238 9.24792C16.451 9.11197 16.6927 8.91502 16.8489 8.65706C17.0087 8.39561 17.0887 8.07491 17.0887 7.69494C17.0887 7.31498 17.0087 6.99078 16.8489 6.72237C16.689 6.45047 16.4454 6.2448 16.1182 6.10536C15.791 5.96244 15.369 5.89098 14.8522 5.89098H12.9559V14.9788H10.8867ZM16.7875 10.1264L19.6152 14.9788H17.3062L14.5287 10.1264H16.7875Z"
      fill="#017E9D"
    />
    <path
      d="M16.8049 10.6507L19.3203 14.5723H19.4095L21.9361 10.6507H24.2953L20.776 16.005L24.351 21.3594H21.9528L19.4095 17.4639H19.3203L16.777 21.3594H14.3899L17.9984 16.005L14.4345 10.6507H16.8049Z"
      fill="#017E9D"
    />
    <path
      d="M1.60473 21.7534L4.83852 25.9223L13.5231 17.0533"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.64861 18.4684V3.35132C4.64861 2.24675 5.54404 1.35132 6.64861 1.35132H26C27.1046 1.35132 28 2.24675 28 3.35132V30C28 31.1046 27.1046 32 26 32H6.64861C5.54404 32 4.64861 31.1046 4.64861 30V29.33"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
  </svg>
);

export const gearsIcon = (
  <svg
    width="0.41428571in"
    height="0.6in"
    viewBox="0 0 29 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="29"
      r="3.75"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="26.5"
      cy="28.5"
      r="1.25"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="20"
      y1="28.75"
      x2="25"
      y2="28.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="23.5397"
      cy="21.1922"
      r="1.25"
      transform="rotate(-44.105 23.5397 21.1922)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="19.0463"
      y1="25.8956"
      x2="22.6366"
      y2="22.4158"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="16"
      cy="19.5"
      r="1.25"
      transform="rotate(-90 16 19.5)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line x1="16" y1="26" x2="16" y2="21" stroke="#017E9D" stroke-width="2.5" />
    <circle
      cx="8.68485"
      cy="22.682"
      r="1.25"
      transform="rotate(-137.016 8.68485 22.682)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="13.4398"
      y1="27.1136"
      x2="9.78214"
      y2="23.7047"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="2.5"
      cy="2.5"
      r="1.25"
      transform="matrix(0 1 1 0 13.5 37)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      y1="-1.25"
      x2="5"
      y2="-1.25"
      transform="matrix(8.74228e-08 1 1 -8.74228e-08 17.25 33)"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="2.5"
      cy="2.5"
      r="1.25"
      transform="matrix(0.73154 0.681798 0.681798 -0.73154 19.7821 36.4423)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      y1="-1.25"
      x2="5"
      y2="-1.25"
      transform="matrix(0.73154 0.681798 0.681798 -0.73154 19.4127 30.9718)"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="2.5"
      cy="2.5"
      r="1.25"
      transform="matrix(-1 0 0 1 8 26)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="7"
      y1="28.75"
      x2="12"
      y2="28.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <circle
      cx="2.5"
      cy="2.5"
      r="1.25"
      transform="matrix(-0.718066 0.695976 0.695976 0.718066 8.51562 32.2727)"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="9.71148"
      y1="34.9434"
      x2="13.3018"
      y2="31.4635"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <path
      d="M12.8333 9.29163L17 9.29163"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M12.0382 6.91296L15.0302 4.01307"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M9.5 6.16663L9.5 1.99996"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M6.71475 6.50745L3.66667 3.66662"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M9.5 12.8334L9.5 17"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M11.6338 11.9052L14.6819 14.746"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2 9.29163L6.16667 9.29163"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M3.66666 14.8999L6.6586 12"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <circle
      cx="9.5"
      cy="9.5"
      r="3.75"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
  </svg>
);

export const plusIcon = (
  <svg
    width="0.38571429in"
    height="0.38571429in"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_6473_196691" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 0C9.44786 0 9.00014 0.447715 9.00014 0.999999V8.99996H1C0.447715 8.99996 0 9.44768 0 9.99996V17C0 17.5522 0.447715 18 0.999999 18H9.00014V26C9.00014 26.5523 9.44786 27 10.0001 27H17.0001C17.5524 27 18.0001 26.5523 18.0001 26V18H26C26.5523 18 27 17.5522 27 17V9.99996C27 9.44768 26.5523 8.99996 26 8.99996H18.0001V1C18.0001 0.447715 17.5524 0 17.0001 0H10.0001Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 0C9.44786 0 9.00014 0.447715 9.00014 0.999999V8.99996H1C0.447715 8.99996 0 9.44768 0 9.99996V17C0 17.5522 0.447715 18 0.999999 18H9.00014V26C9.00014 26.5523 9.44786 27 10.0001 27H17.0001C17.5524 27 18.0001 26.5523 18.0001 26V18H26C26.5523 18 27 17.5522 27 17V9.99996C27 9.44768 26.5523 8.99996 26 8.99996H18.0001V1C18.0001 0.447715 17.5524 0 17.0001 0H10.0001Z"
      fill="none"
    />
    <path
      d="M9.00014 8.99996V11.5H11.5001V8.99996H9.00014ZM9.00014 18H11.5001V15.5H9.00014V18ZM18.0001 18V15.5H15.5001V18H18.0001ZM18.0001 8.99996H15.5001V11.5H18.0001V8.99996ZM11.5001 0.999999C11.5001 1.82843 10.8286 2.5 10.0001 2.5V-2.5C8.06715 -2.5 6.50014 -0.932998 6.50014 0.999999H11.5001ZM11.5001 8.99996V0.999999H6.50014V8.99996H11.5001ZM1 11.5H9.00014V6.49996H1V11.5ZM2.5 9.99996C2.5 10.8284 1.82843 11.5 1 11.5V6.49996C-0.932996 6.49996 -2.5 8.06697 -2.5 9.99996H2.5ZM2.5 17V9.99996H-2.5V17H2.5ZM0.999999 15.5C1.82843 15.5 2.5 16.1715 2.5 17H-2.5C-2.5 18.933 -0.933 20.5 0.999999 20.5V15.5ZM9.00014 15.5H0.999999V20.5H9.00014V15.5ZM11.5001 26V18H6.50014V26H11.5001ZM10.0001 24.5C10.8286 24.5 11.5001 25.1716 11.5001 26H6.50014C6.50014 27.933 8.06714 29.5 10.0001 29.5V24.5ZM17.0001 24.5H10.0001V29.5H17.0001V24.5ZM15.5001 26C15.5001 25.1716 16.1717 24.5 17.0001 24.5V29.5C18.9331 29.5 20.5001 27.933 20.5001 26H15.5001ZM15.5001 18V26H20.5001V18H15.5001ZM26 15.5H18.0001V20.5H26V15.5ZM24.5 17C24.5 16.1715 25.1716 15.5 26 15.5V20.5C27.933 20.5 29.5 18.933 29.5 17H24.5ZM24.5 9.99996V17H29.5V9.99996H24.5ZM26 11.5C25.1716 11.5 24.5 10.8284 24.5 9.99996H29.5C29.5 8.06697 27.933 6.49996 26 6.49996V11.5ZM18.0001 11.5H26V6.49996H18.0001V11.5ZM15.5001 1V8.99996H20.5001V1H15.5001ZM17.0001 2.5C16.1717 2.5 15.5001 1.82842 15.5001 1H20.5001C20.5001 -0.932991 18.9331 -2.5 17.0001 -2.5V2.5ZM10.0001 2.5H17.0001V-2.5H10.0001V2.5Z"
      fill="#017E9D"
      mask="url(#path-1-inside-1_6473_196691)"
    />
  </svg>
);

export const nasalRinseIcon = (
  <svg
    width="0.37142857in"
    height="0.7in"
    viewBox="0 0 26 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 21C1.25 17.2721 4.27208 14.25 8 14.25H18C21.7279 14.25 24.75 17.2721 24.75 21V46C24.75 46.9665 23.9665 47.75 23 47.75H3C2.0335 47.75 1.25 46.9665 1.25 46V21Z"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <path
      d="M18.5 14H7.5V7.31522C7.5 7.11005 7.56311 6.90984 7.68077 6.74176L10.7014 2.42654C10.8886 2.15921 11.1943 2 11.5207 2H13H14.4666C14.8 2 15.1114 2.16613 15.2971 2.44301L18.3305 6.96604C18.441 7.13078 18.5 7.32467 18.5 7.52303L18.5 14Z"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="1"
      y1="22.75"
      x2="25"
      y2="22.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="7"
      y1="9.75"
      x2="18"
      y2="9.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="1"
      y1="38.75"
      x2="25"
      y2="38.75"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <mask id="path-6-inside-1_6460_195409" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4564 29.8271L13.0058 26L10.5552 29.8271C10.2056 30.3183 10 30.9191 10 31.568C10 33.2281 11.3457 34.5738 13.0058 34.5738C14.6659 34.5738 16.0116 33.2281 16.0116 31.568C16.0116 30.9191 15.806 30.3183 15.4564 29.8271Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4564 29.8271L13.0058 26L10.5552 29.8271C10.2056 30.3183 10 30.9191 10 31.568C10 33.2281 11.3457 34.5738 13.0058 34.5738C14.6659 34.5738 16.0116 33.2281 16.0116 31.568C16.0116 30.9191 15.806 30.3183 15.4564 29.8271Z"
      fill="#017E9D"
    />
    <path
      d="M13.0058 26L15.1112 24.6519L13.0058 21.364L10.9004 24.6519L13.0058 26ZM15.4564 29.8271L13.3511 31.1752L13.3841 31.2268L13.4196 31.2767L15.4564 29.8271ZM10.5552 29.8271L12.592 31.2767L12.6275 31.2268L12.6605 31.1752L10.5552 29.8271ZM10.9004 27.3481L13.3511 31.1752L17.5618 28.479L15.1112 24.6519L10.9004 27.3481ZM12.6605 31.1752L15.1112 27.3481L10.9004 24.6519L8.44983 28.479L12.6605 31.1752ZM12.5 31.568C12.5 31.4556 12.5338 31.3585 12.592 31.2767L8.51834 28.3775C7.87741 29.2781 7.5 30.3827 7.5 31.568H12.5ZM13.0058 32.0738C12.7265 32.0738 12.5 31.8473 12.5 31.568H7.5C7.5 34.6088 9.96503 37.0738 13.0058 37.0738V32.0738ZM13.5116 31.568C13.5116 31.8473 13.2851 32.0738 13.0058 32.0738V37.0738C16.0466 37.0738 18.5116 34.6088 18.5116 31.568H13.5116ZM13.4196 31.2767C13.4778 31.3585 13.5116 31.4556 13.5116 31.568H18.5116C18.5116 30.3827 18.1342 29.2781 17.4933 28.3775L13.4196 31.2767Z"
      fill="#017E9D"
      mask="url(#path-6-inside-1_6460_195409)"
    />
  </svg>
);

export const pillsIcon = (
  <svg
    width="0.41428571in"
    height="0.38571429in"
    viewBox="0 0 29 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.75 7.62192C27.75 10.9882 25.0587 13.6906 21.7712 13.6906C18.4837 13.6906 15.7924 10.9882 15.7924 7.62192C15.7924 4.25566 18.4837 1.55322 21.7712 1.55322C25.0587 1.55322 27.75 4.25566 27.75 7.62192Z"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      y1="-1.25"
      x2="11.9111"
      y2="-1.25"
      transform="matrix(0.702725 0.711462 -0.702725 0.711462 16.8247 4.15491)"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <path
      d="M8.74515 9.61532L17.07 17.9555C18.6366 19.525 18.7252 22.1699 17.2691 23.8629C15.8129 25.556 13.3625 25.6568 11.7959 24.0873L7.63348 19.9169L3.47105 15.7464C1.90447 14.1769 1.81578 11.5321 3.27196 9.83904C4.72813 8.14598 7.17857 8.04582 8.74515 9.61532Z"
      fill="none"
      stroke="#017E9D"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
    <line
      x1="6.94223"
      y1="18.9095"
      x2="12.6261"
      y2="13.3602"
      stroke="#017E9D"
      stroke-width="2.5"
    />
  </svg>
);

export const pillBottleIcon = (
  <svg
    width="0.3in"
    height="0.55714286in"
    viewBox="0 0 21 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_6460_196083" fill="white">
      <path d="M1.2836 12.8373H18.8758V34C18.8758 36.7614 16.6372 39 13.8758 39H6.2836C3.52218 39 1.2836 36.7614 1.2836 34V12.8373Z" />
    </mask>
    <path
      d="M1.2836 12.8373H18.8758V34C18.8758 36.7614 16.6372 39 13.8758 39H6.2836C3.52218 39 1.2836 36.7614 1.2836 34V12.8373Z"
      fill="none"
    />
    <path
      d="M1.2836 12.8373H18.8758H1.2836ZM21.3758 34C21.3758 38.1421 18.0179 41.5 13.8758 41.5H6.2836C2.14146 41.5 -1.2164 38.1421 -1.2164 34H3.7836C3.7836 35.3807 4.90289 36.5 6.2836 36.5H13.8758C15.2565 36.5 16.3758 35.3807 16.3758 34H21.3758ZM6.2836 41.5C2.14146 41.5 -1.2164 38.1421 -1.2164 34V12.8373H3.7836V34C3.7836 35.3807 4.90289 36.5 6.2836 36.5V41.5ZM21.3758 12.8373V34C21.3758 38.1421 18.0179 41.5 13.8758 41.5V36.5C15.2565 36.5 16.3758 35.3807 16.3758 34V12.8373H21.3758Z"
      fill="#017E9D"
      mask="url(#path-1-inside-1_6460_196083)"
    />
    <mask id="path-3-inside-2_6460_196083" fill="white">
      <path d="M1.75319 2.23084C1.75319 1.12627 2.64862 0.230835 3.75319 0.230835H16.0769C17.1815 0.230835 18.0769 1.12627 18.0769 2.23083V5.84212H1.75319V2.23084Z" />
    </mask>
    <path
      d="M1.75319 2.23084C1.75319 1.12627 2.64862 0.230835 3.75319 0.230835H16.0769C17.1815 0.230835 18.0769 1.12627 18.0769 2.23083V5.84212H1.75319V2.23084Z"
      fill="none"
    />
    <path
      d="M-0.746811 2.23083C-0.746811 -0.254446 1.26791 -2.26917 3.75319 -2.26917H16.0769C18.5622 -2.26917 20.5769 -0.254446 20.5769 2.23083L15.5769 2.73083H4.25319L-0.746811 2.23083ZM18.0769 5.84212H1.75319H18.0769ZM-0.746811 5.84212V2.23083C-0.746811 -0.254446 1.26791 -2.26917 3.75319 -2.26917L4.25319 2.73083V5.84212H-0.746811ZM16.0769 -2.26917C18.5622 -2.26917 20.5769 -0.254446 20.5769 2.23083V5.84212H15.5769V2.73083L16.0769 -2.26917Z"
      fill="#017E9D"
      mask="url(#path-3-inside-2_6460_196083)"
    />
    <mask id="path-5-inside-3_6460_196083" fill="white">
      <rect y="5.36682" width="20.1167" height="7.70427" rx="2" />
    </mask>
    <rect
      y="5.36682"
      width="20.1167"
      height="7.70427"
      rx="2"
      fill="none"
      stroke="#017E9D"
      stroke-width="5"
      mask="url(#path-5-inside-3_6460_196083)"
    />
    <line
      x1="4.81256"
      y1="6.18335"
      x2="4.81256"
      y2="12.8368"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="9.63428"
      y1="6.35217"
      x2="9.63428"
      y2="13.0056"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="14.7351"
      y1="6.35217"
      x2="14.7351"
      y2="13.0056"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="2.56841"
      y1="20.3818"
      x2="17.1209"
      y2="20.3818"
      stroke="#017E9D"
      stroke-width="2.5"
    />
    <line
      x1="2.56841"
      y1="25.5178"
      x2="17.1209"
      y2="25.5178"
      stroke="#017E9D"
      stroke-width="2.5"
    />
  </svg>
);
